export default {
  title: 'Actualizaciones',
  fields: {
    app_version: 'Versión de app',
    description: 'Descripción',
    created_at: 'Creado el',
  },
};
